import React, { FormEvent, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "../common/Motion";

const WHATSAPP_URL = "https://wa.me/923335274666?text=Hello%20Visiosol%2C%20I%27d%20like%20to%20discuss%20a%20project%20with%20your%20team.";

const Contact = () => {
  const [status, setStatus] = useState("");
  const [isSending, setIsSending] = useState(false);
  const reduceMotion = useReducedMotion();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    setIsSending(true);
    setStatus("Sending…");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.get("name"),
          email: formData.get("email"),
          service: formData.get("service"),
          details: formData.get("details"),
        }),
      });

      if (!response.ok) {
        const result = await response.json().catch(() => null);
        throw new Error(result?.error || "Contact request failed");
      }

      form.reset();
      setStatus("Thanks — we’ll be in touch shortly.");
    } catch (error) {
      const message = error instanceof Error ? error.message : "";
      setStatus(message && message !== "Contact request failed"
        ? message
        : "We couldn’t send that. Please email info@visiosol.tech.");
    } finally {
      setIsSending(false);
    }
  };

  return <section id="contact" className="section contact-section">
    <motion.div className="site-shell contact-grid" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
      <motion.div variants={fadeUp} className="contact-copy"><p className="eyebrow">Start with the opportunity</p><h2>Where could intelligence change the way you work?</h2><p>Share the decision, workflow, or customer experience you want to improve. We’ll help you identify a practical AI starting point and the path from prototype to production.</p><div className="contact-links"><a href="mailto:info@visiosol.tech">info@visiosol.tech</a><a href="tel:+923335274666">Call: +92 333 5274666</a><a href={WHATSAPP_URL} target="_blank" rel="noreferrer">WhatsApp: +92 333 5274666</a></div></motion.div>
      <motion.form variants={fadeUp} className="contact-form" onSubmit={handleSubmit}>
        <label>Name<input required name="name" autoComplete="name" maxLength={100} placeholder="Your name" /></label>
        <label>Work email<input required type="email" name="email" autoComplete="email" maxLength={254} placeholder="you@company.com" /></label>
        <label>How can we help?<select required name="service" defaultValue=""><option value="" disabled>Select a service</option><option>AI strategy & readiness</option><option>AI agents & copilots</option><option>Intelligent automation</option><option>Data & knowledge systems</option><option>AI-native product</option><option>FBRConnect</option><option>Other</option></select></label>
        <label>Project details<textarea required name="details" maxLength={5000} rows={4} placeholder="A brief description of your goal, timeline, or challenge" /></label>
        <div className="contact-actions">
          <button className="button button-primary" type="submit" disabled={isSending}>{isSending ? "Sending…" : "Send enquiry"} <span aria-hidden="true">→</span></button>
          <a className="button button-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Contact Visiosol on WhatsApp">WhatsApp us <span aria-hidden="true">↗</span></a>
        </div>
        <p className="form-status" role="status" aria-live="polite">{status}</p>
      </motion.form>
    </motion.div>
  </section>;
};

export default Contact;
